<div class="h-full w-full flex flex-col min-h-0">
  <p-toolbar #toolbarDiv>
    <ng-template #start>
      <div class="toolbar-menu">
        <p-selectButton
          [options]="plotView"
          [ngModel]="selectedPlotView()"
          (onChange)="selectPlotView($event)"
          [allowEmpty]="false"
        ></p-selectButton>
      </div>
    </ng-template>
    <ng-template #end>
      @if (selectedPlotView() === '3d') {
        <div class="flex gap-3 items-center pr-3">
          <label class="flex gap-1 items-center">
            <p-checkbox size="small" [ngModel]="isRotating()" (onChange)="onRotatingChange($event)" binary="true"/>
            Rotate
          </label>
          <label class="flex gap-1 items-center">
            <p-checkbox size="small" [ngModel]="isShowingProjections()" (onChange)="onProjectionsChange($event)" binary="true"/>
            Projections
          </label>
        </div>
      }
    </ng-template>
  </p-toolbar> 

    <app-tool-loader [isLoading]="isLoading()" positionUnset="true" class="flex-1 min-h-0">
      <div class="flex-1 min-h-0 overflow-hidden w-full p-2 flex flex-col">
        @if (!isLoading()) {
          @if (selectedPlotView() === '3d') {
            <app-three-dee-plot
              class="flex-1 min-h-0"
              #threeDPlot
              [xyzData]="trajectoryXyzData()"
              [trajectoryPlotStore]="trajectoryPlotStore()"
              [isDarkMode]="isDarkMode()"
              [longLengths]="longLengthUnits()"
            ></app-three-dee-plot>
          } @else {
            <app-two-dee-plot
              class="flex-1 min-h-0"
              [selectedPlot]="selectedPlotView()"
              [trajectoryData]="trajectoryData()"
              [userUnits]="uu()"
              [trajectoryPlotStore]="trajectoryPlotStore()"
              [dlsOverrides]="dlsOverrides()"
            ></app-two-dee-plot>
          }
        }
    </div>
  </app-tool-loader>
</div>
